module.exports = __webpack_public_path__ + "static/1ac461e3-5be5-478c-ae44-666ad95ee7bb-original.a10c9a4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/bud-vase-sky-blue/1ac461e3-5be5-478c-ae44-666ad95ee7bb-original.jpg
// module id = 941
// module chunks = 168707334958949